module.exports = __webpack_public_path__ + "static/weixin-896223531038fa7702a03bf5577bff4f.png";